import React, { useEffect, useState } from "react";
import inCog from "../assets/inCog.svg";

const Target = (props) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      if (props.usedIDs[props.target.id]) {
        return;
      }
      props.onAddId(props.target.id);
      console.log("props", props);
      setVisible(false);
      props.ontargetExpire(props.target);
    }, props.delay);
  }, [props.delay]);

  return visible ? (
    <div
      onClick={() => {
        setVisible(false);
        props.onTargetClick(props.target);
      }}
      style={props.target.loc}
      className="target"
    >
      <image className="incog" src={inCog}></image>
    </div>
  ) : (
    <React.Fragment />
  );
};

export default Target;
